// extracted by mini-css-extract-plugin
module.exports = {"footer":"_103a151b99--footer--maOMF","user_name":"_103a151b99--user_name--wEz3v","offer":"_103a151b99--offer--u90nJ"};